<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>拆分波次</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
          :span="24"
        >
          <span>待拆分订单</span>
          <el-button
            type="primary"
            style="margin-left: auto"
            size="mini"
            @click="showOrderGoods('order')"
            >查看订单商品</el-button
          >
          <el-button type="primary" size="mini" @click="doSplit('order')"
            >拆分波次</el-button
          >
        </div>
        <div style="margin-bottom: 0; margin-left: 25px">
          <el-form :model="form">
            <el-form-item>
              <el-checkbox-group v-model="form.split_orders">
                <el-checkbox
                  v-for="order in resData.orders"
                  :key="order.order_id"
                  :label="order.order_id"
                  >{{ order.order_sn }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
          :span="24"
        >
          <span>商品信息</span>
          <el-input
            v-model="form.goods_no"
            size="mini"
            style="width: 300px; margin-left: auto"
            placeholder="商品货号，多个货号用英文逗号/中文逗号/空格隔开"
            @keyup.native.enter="showOrderGoods('goods')"
          ></el-input>
          <el-button type="primary" size="mini" @click="showOrderGoods('goods')"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="doSplit('sku')"
            >拆分波次</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData.info"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.info"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="order_sn"
              label="商品订单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              prop="img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <img
                  :key="scope.row.img"
                  :src="scope.row.img"
                  style="width: 80px; height: 80px"
                  @click="showImages(scope.row.img)"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <!--<el-table-column align="center" prop="init_num" label="原始数量"></el-table-column>-->
            <el-table-column
              align="center"
              prop="wave_picking_info_num"
              label="当前数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shop_price"
              label="平台价"
            ></el-table-column>

            <el-table-column fixed="right" label="拆分数量" width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.num"
                  type="text"
                  size="mini"
                  placeholder="输入数量"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--<div style="text-align: right;padding: 25px;" v-if="resData">-->
        <!--<el-pagination @current-change="handleCurrentChange" :current-page.sync="curPage" background layout="total, prev, pager, next, jumper " :total="resData.count" :page-size="100">-->
        <!--</el-pagination>-->
        <!--</div>-->
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage";

export default {
  components: { PreviewImage },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        orders: [],
        info: [],
      },
      form: {
        wave_picking_info_id: 0,
        wave_picking_id: this.$route.params.id,
        num: [],
        split_orders: [],
      },
      msg: "",
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/getOrders",
      curPage: 1,
      detailcurPage: 1,
      filterFold: false,
      wave_picking_id: this.$route.params.id,
      showbox: false,
      images: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    showImages(img) {
      this.showbox = true;
      this.images = [img];
    },
    closeBox() {
      this.showbox = false;
    },
    doSplit(type) {
      this.$confirm("是否确定拆分波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type == "order") {
            this.form.split_wave_picking_id = this.form.wave_picking_id;
            this.$http
              .post("/erp/WavePicking/doSplit", this.filteredForm)
              .then((res) => {
                if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else {
                  this.$message.success(res.data.msg);
                  this.form.split_orders = [];
                  this.fetchData(true);
                }
              });
          } else {
            const num = [];
            this.resData.info.forEach((item) => {
              if (item.num > 0) {
                num.push({
                  wave_picking_info_id: item.wave_picking_info_id,
                  num: item.num,
                });
              }
            });

            const msg = "";
            if (msg == "") {
              this.$http
                .post("/erp/WavePickingInfo/doSplitBySku", {
                  wave_picking_id: this.form.wave_picking_id,
                  num,
                })
                .then((res) => {
                  this.loading = false;
                  if (res.data.code !== 200) {
                    this.$message.error(res.data.msg);
                  } else {
                    this.$message.success(res.data.msg);
                    this.fetchData(true);
                    this.showOrderGoods();
                  }
                });
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    showOrderGoods(type) {
      if (type == "order") {
        this.form.goods_no = "";
      }
      this.$http
        .post("/erp/WavePickingInfo/beforeSplit", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            // for (let key in res.data.data.info) {
            //     this.form.num[res.data.data.info[key].wave_picking_info_id] = 0;
            // }
            this.resData.info = res.data.data.info;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData.orders = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/SplitWavePicking.vue